module.exports = __webpack_public_path__ + "9b0effaefce818b5c57df4b8142c848a.svg";